
import { combineReducers } from "redux";
import account from "./AccountReducer";
import general from "./GeneralReducer";

export default combineReducers({ general,account });
